module.exports = __webpack_public_path__ + "img/skeleton3.e3a6ac4a.jpg";